import { User, UserId, RoleId, BuildingId, OrgId } from 'shared/models';
import UUID from 'util/UUID';

export const Actions = {
    CREATE_USER_SUCCESS: 'CREATE_USER_SUCCESS',

    GET_USERS_REQUEST: 'GET_USERS_REQUEST',
    GET_USERS_SUCCESS: 'GET_USERS_SUCCESS',
    GET_USERS_FAILURE: 'GET_USERS_FAILURE',

    GET_USER_REQUEST: 'GET_USER_REQUEST',
    GET_USER_SUCCESS: 'GET_USER_SUCCESS',
    GET_USER_FAILURE: 'GET_USER_FAILURE',

    UPDATE_USER_SUCCESS: 'UPDATE_USER_SUCCESS',

    DELETE_USER_REQUEST: 'DELETE_USER_REQUEST',
    DELETE_USER_SUCCESS: 'DELETE_USER_SUCCESS',
    DELETE_USER_FAILURE: 'DELETE_USER_FAILURE',
};

export type UserDetails = {
    id?: UserId;
    login: string;
    displayName?: string;
    emailAddress?: string | null;
    phoneNumber?: string;
    password?: string;
    roleIds: RoleId[];
    orgId: OrgId | null;
    enabled: boolean;
};

export const createUserSuccess = (user: User, meta: { buildingId?: BuildingId }) => ({
    type: Actions.CREATE_USER_SUCCESS,
    payload: user,
    meta,
});

export type GetUsersRequestParameters = {
    searchText?: string;
    roles?: Record<RoleId, boolean>;
    orgs?: Record<OrgId, boolean>;
    sortCriteria?: string;
    sortDirection?: string;
    maxRows?: number;
    page?: number;
};

export const getUsersRequest = (params: GetUsersRequestParameters = {}, meta: { ref?: string; callback?: (users: User[], more: boolean) => unknown } = {}) => ({
    type: Actions.GET_USERS_REQUEST,
    payload: params,
    meta: {
        ref: UUID.generate(),
        ...meta,
    },
});
export const getUsersSuccess = (users: User[], meta: { more: boolean; ref: string }) => ({
    type: Actions.GET_USERS_SUCCESS,
    payload: users,
    meta,
});
export const getUsersFailure = (err: Error, meta: { ref: string }) => ({
    type: Actions.GET_USERS_FAILURE,
    error: true,
    payload: err,
});

export const getUserRequest = (userId: UserId) => ({
    type: Actions.GET_USER_REQUEST,
    payload: userId,
});
export const getUserSuccess = (user: User) => ({
    type: Actions.GET_USER_SUCCESS,
    payload: user,
});
export const getUserFailure = (err: Error, meta: { userId: UserId }) => ({
    type: Actions.GET_USER_FAILURE,
    error: true,
    payload: err,
    meta,
});


export const updateUserSuccess = (user: User) => ({
    type: Actions.UPDATE_USER_SUCCESS,
    payload: user,
});


export const deleteUserRequest = (userId: string) => ({
    type: Actions.DELETE_USER_REQUEST,
    payload: userId,
});
export const deleteUserSuccess = (id: string) => ({
    type: Actions.DELETE_USER_SUCCESS,
    payload: null,
    meta: { id },
});
export const deleteUserFailure = (err: Error, id: string) => ({
    type: Actions.DELETE_USER_FAILURE,
    payload: err,
    error: true,
    meta: { id },
});
